import { Component } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";

import { ApplicationWizardService } from "../application-wizard.service";
import { ValidationService } from "../../../../common/validation/validation.service";
import { AbstractWizardStepComponent } from "../../../wizard-dialog/abstract-wizard-step.component";
import { ApplicationPortsComponent } from "../application-ports/application-ports.component";
import { ApplicationSelectTypeComponent } from "../application-select-type/application-select-type.component";
import { ApplicationWizardNetworkService } from "../models";

@Component({
	templateUrl: "./application-network-service.component.html"
})
export class ApplicationNetworkServiceComponent extends AbstractWizardStepComponent<void> {
	public form: FormGroup;

	constructor(
		private service: ApplicationWizardService,
		private formBuilder: FormBuilder,
		private validationService: ValidationService
	) {
		super();

		this.form = this.formBuilder.group({
			ip: [
				this.service.getValue("ip", ""),
				Validators.compose([
					Validators.required,
					this.validationService.domainOrIpSingle
				])
			]
		});
	}

	public goPrevious() {
		this.service.processNetworkService(this.formValue);
	}

	public get title() {
		return this.service.applicationState.isCreate ?
			"application.wizard.title.create" : "application.wizard.title.update";
	}

	public get description() {
		return "application.wizard.networkService.description";
	}

	public get nextStep() {
		return ApplicationPortsComponent;
	}

	public get previousStep() {
		return ApplicationSelectTypeComponent;
	}

	public get isFormValid() {
		return this.form.valid;
	}

	public performPrevious() {
		this.service.processNetworkService(this.formValue);
	}

	public performNext() {
		this.service.processNetworkService(this.formValue);
	}

	public get showProgressBar() {
		return false;
	}

	private get formValue(): ApplicationWizardNetworkService {
		return this.form.getRawValue();
	}
}
